export default __webpack_public_path__ + "static/media/audit.1d6ccee0.svg";